export enum AccountRoutePathsEnum {
  ACCOUNT = 'account',
}
